import { useCallback, useState } from "react";
import { toast } from "sonner";
import { useSubscriptionPreapproval } from "@/hooks/useSubscriptionPreapproval";
import { subscriptionStartErrorMessage } from "@/lib/payment-error-message";

export function usePaywallPlanSubscribe<T extends { id: string }>(orgId: string | null) {
  const [plan, setPlan] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const { preapproval, startAuthorize } = useSubscriptionPreapproval(plan ? orgId : null);

  const choose = useCallback((next: T) => setPlan(next), []);

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (!open && !loading) setPlan(null);
    },
    [loading],
  );

  const confirm = useCallback(
    async (payerEmail: string | undefined) => {
      if (!plan) return;
      setLoading(true);
      try {
        const { init_point } = await startAuthorize(plan.id, payerEmail);
        toast.info("Te redirigimos a MercadoPago para autorizar el cobro automático.");
        window.location.href = init_point;
      } catch (err) {
        console.error("Paywall subscription error:", err);
        toast.error(subscriptionStartErrorMessage(err));
        setLoading(false);
      }
    },
    [plan, startAuthorize],
  );

  return {
    plan,
    open: plan !== null,
    loading,
    hasPreapproval: preapproval !== null,
    choose,
    onOpenChange,
    confirm,
  };
}
